import { render, staticRenderFns } from "./_AssetForm.vue?vue&type=template&id=4ed91217"
import script from "./_AssetForm.vue?vue&type=script&lang=ts"
export * from "./_AssetForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports